<template>
  <el-dialog
    title="礼品卡制作"
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      :model="formInfo"
      :rules="formRules"
      ref="form"
      label-width="100px"
      v-loading="loading"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="主题" prop="topicName">
            <el-input v-model="formInfo.topicName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="卡片名称" prop="cardName">
            <el-input v-model="formInfo.cardName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="卡片封面" prop="topicCover">
            <el-upload
              class="avatar-uploader fl"
              :data="postData"
              :accept="acceptImage"
              action="https://up.qiniup.com"
              :show-file-list="false"
              :on-success="handlePictureCardPreview"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="祝福语" prop="blessingWords">
            <el-input
              type="textarea"
              maxlength="255"
              show-word-limit
              v-model="formInfo.blessingWords"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="卡片面值" prop="amount">
            <el-input-number
              v-model="formInfo.amount"
              clearable
              :min="0"
              placeholder="请输入卡片面值"
              controls-position="right"
              style="width: 100%;"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="卡片类型" prop="cardType">
            <el-select
              v-model="formInfo.cardType"
              clearable
              filterable
              placeholder="请选择卡片类型"
              style="width: 100%;"
            >
              <el-option
                v-for="item in dataSource.cardTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期类型" prop="validType">
            <el-select
              v-model="formInfo.validType"
              clearable
              filterable
              placeholder="请选择有效期类型"
              style="width: 100%;"
            >
              <el-option
                v-for="item in dataSource.validTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期" prop="validValue">
            <el-input v-model="formInfo.validValue" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="formInfo.status"
              clearable
              filterable
              placeholder="请选择状态"
              style="width: 100%;"
            >
              <el-option
                v-for="item in dataSource.statusOptions"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              maxlength="255"
              show-word-limit
              v-model="formInfo.remark"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="使用说明:">
            <div id="editor"></div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { genUpToken } from "@/util/qiniuToken.js";
import { giftCardSpecSave } from "@/api/giftCard";
import E from "wangeditor";
export default {
  name: "GiftCardEdit",
  data() {
    var validValueValidation = (rule, value, callback) => {
      if (this.formInfo.validType == 1) {
        if (!value) {
          callback(new Error("请输入有效期"));
        }
        // yyyy-MM-dd
        if (
          !/(^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$)/.test(
            value
          )
        ) {
          callback(new Error("请输入正确的有效期:yyyy-MM-dd"));
        }
        // 是否小于当前时间
        if (new Date(value) < new Date()) {
          callback(new Error("请输入正确的有效期:小于当前时间"));
        }
        callback();
      } else if (this.formInfo.validType == 2) {
        if (!value) {
          callback(new Error("请输入有效期"));
        }
        // 是否为整数
        if (!/(^[1-9]\d*$)/.test(value)) {
          callback(new Error("请输入正确的有效期:整数"));
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      postData: { token: "" },
      qiniuaddr: "pic.allscs.cn", // 这是七牛云空间的外链默认域名
      ruleImg: "imageView2/0/q/75|imageslim", //规则
      imageUrl: "",
      acceptImage: "image/jpeg,image/jpg,image/png",

      editor: undefined,

      dialogVisible: false,
      loading: false,
      dataSource: [],
      formInfo: {},
      formRules: {
        topicName: [{ required: true, message: "请输入主题", trigger: "blur" }],
        cardName: [
          { required: true, message: "请输入卡片名称", trigger: "blur" }
        ],
        cardType: [
          { required: true, message: "请选择卡片类型", trigger: "change" }
        ],
        amount: [
          { required: true, message: "请输入卡片面值", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        validType: [
          { required: true, message: "请选择有效期类型", trigger: "change" }
        ],
        validValue: [{ validator: validValueValidation, trigger: "blur" }]
      }
    };
  },
  created() {
    this.getQiniuToken();
  },
  mounted() {},
  methods: {
    createEditor() {
      if (this.editor) {
        this.editor.destroy();
      }
      this.editor = new E("#editor");
      console.log(this.editor);
      this.editor.config.zIndex = 0;
      this.editor.create();
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    open(info, dataSource) {
      this.dialogVisible = true;
      this.formInfo = info || {};
      this.imageUrl = this.formInfo.topicCover;
      this.dataSource = dataSource;
      this.loading = false;
      // this.$nextTick(() => {
      //   this.$refs["form"].resetFields();
      // });
      setTimeout(() => {
        this.createEditor();
        this.editor.txt.html(this.formInfo.useDescription);
      }, 100);
    },
    // 上传图片
    getQiniuToken() {
      var token = "";
      var policy = {};
      var bucket = "hohofast";
      var AK = "VYiFElH26Am5EbV9T3nACEfNt6xBRz6gEREDFlis";
      var SK = "sFELHoXSwB8NpiWpPj2Wk7theJCO7Iil-2rwSj31";
      var deadline = Math.round(new Date().getTime() / 1000) + 3600;
      policy.scope = bucket;
      policy.deadline = deadline;
      token = genUpToken(AK, SK, policy);
      this.postData.token = token;
    },
    handlePictureCardPreview(res, file) {
      this.imageUrl = "http://" + this.qiniuaddr + "/" + res.key + "?imageslim";
      this.formInfo.topicCover = this.imageUrl;
    },
    beforeAvatarUpload(file) {
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG 格式 和Png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },

    // 提交表单
    dataFormSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.saveData();
        }
      });
    },
    getFormData() {
      const data = this.formInfo;
      data.useDescription = this.editor.txt.text();
      data.useDescriptionHtml = this.editor.txt.html();
      return data;
    },
    saveData() {
      this.loading = true;
      const data = this.getFormData();
      //2024年，我祝你龍來運轉！
      // 我祝你龍來運轉！
      giftCardSpecSave(data)
        .then(res => {
          if (res.data.status == 100) {
            this.$message.success("保存成功");
            this.handleClose();
            this.$emit("refresh");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.avatar-uploader {
  width: 360px;
  height: 100px;
  margin-right: 20px;
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 360px;
    height: 100px;
    line-height: 100px !important;
    text-align: center;
  }
  .avatar {
    width: 360px;
    height: 100px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// edit.vue?25d393c3